import { useId } from 'react'
import { Check, X } from 'lucide-react'
import { PasswordInput } from '../common/PasswordInput'
import { PASSWORD_RULES, getPasswordChecks } from '@/lib/validatePassword'
import styles from './PasswordRequirementsField.module.css'

export function PasswordRequirementsField({
  id,
  label = 'Password',
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  autoComplete = 'new-password',
  autoFocus = false,
}) {
  const generatedId = useId()
  const inputId = id || `password-${generatedId}`
  const requirementsId = `${inputId}-requirements`
  const checks = getPasswordChecks(value || '')

  return (
    <div>
      <PasswordInput
        id={inputId}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        describedBy={requirementsId}
        size="large"
      />
      <ul id={requirementsId} className={styles.list} aria-live="polite">
        {PASSWORD_RULES.map((rule) => {
          const passed = checks[rule.key]
          return (
            <li
              key={rule.key}
              className={`${styles.item} ${passed ? styles.pass : styles.pending}`}
            >
              {passed ? (
                <Check size={14} aria-hidden="true" className={styles.icon} />
              ) : (
                <X size={14} aria-hidden="true" className={styles.icon} />
              )}
              <span>{rule.label}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
